import React from "react"
import type { PreviewTemplateComponentProps } from "decap-cms-core"

const ItemPreview: React.FC<PreviewTemplateComponentProps> = props => {
  const items = props.entry.getIn(["data", "items"]) as Array<string>

  return (
    <ol className="flew-row flex flex-wrap">
      {items.map((_, index: number) => {
        const image = props.entry.getIn([
          "data",
          "items",
          index,
          "meta",
          "image",
        ])

        return (
          <div
            key={index}
            className="group relative w-1/2 cursor-zoom-in lg:w-1/4 xl:w-2/12"
          >
            <img
              key={index}
              alt=""
              src={props.getAsset(image).toString()}
              className="aspect-square w-full object-cover object-center"
            />
            <span className="absolute inset-0 flex items-center justify-center bg-white/80 p-2 text-center font-bold text-black opacity-0 transition-opacity duration-100 ease-in-out group-hover:opacity-100">
              {image}
            </span>
          </div>
        )
      })}
    </ol>
  )
}

export default ItemPreview
